<template>
	<section
		class="container-form-parrainage clear-after">
		<div class="sscontainer">

			<p>Newsletter COOLOC <span>Bons plans, dernières actualités, etc.</span></p>
			<form
				class="clear-after"
				id="form-parrainage"
				action="#"
				method="post"
				accept-charset="UTF-8"
				@submit="submit">
				<div
					class="form-group form-sans-label form-parrainage-email">
					<div>
						<label
						for="form-parrainage-email">Renseignez votre adresse e-mail :</label>
						<input
						type="email"
						id="form-parrainage-email"
						name="parrainageemail"
						placeholder="Renseignez votre adresse e-mail"
						v-model="email">
					</div>
				</div>
				<button type="button"
					@click="submit"
					class="red-button-arrow" :class="{ loading }"><span>S'inscrire</span>
				</button>
			</form>
		</div>

    <simplert :useRadius="false" :useIcon="true" ref="alert"></simplert>
    
		<div id="test-result" v-if="isSubmitted">
			<div>
				<hr>
				<div>
					<div class="panel panel-default">
						<div class="panel-heading">
							<h4>The Data</h4>
						</div>
						<div class="panel-body">
							<p>Email parrainage: {{ email }}</p>
							<br>
							<h4>Data récurrentes supplémentaires ?</h4>
							<p>Nombre de Matching: {{ userData.nbrMatching }}</p>
							<p>Nombre de Favoris: {{ userData.nbrFavoris }}</p>
							<br>
							<h4>Data récurrentes</h4>
							<p>Prénom: {{ profilData.prenom }}</p>
							<p>Src de la photo de profil: {{ profilData.SrcPhotoUser }}</p>
							<p>Nombre de nouveaux messages chat: {{ userData.nbrNouveauxMessage }}</p>
							<p>Progress bar: {{ progressBarValeur }}%</p><br>
						</div>
					</div>
				</div>
				<hr><br>
			</div>
		</div>
		<simple-popup :popup="popupInfo"></simple-popup>
	</section>

</template>

<script>
import Simplert from 'vue2-simplert'
import { registrationHelpers } from '../../main'
export default {
  name: 'home-newsletter',
  data: () => ({
    // Container Data différent pour parrainage ?
    // Peut-être multiple
    email: '',
    loading: false,
    isSubmitted: false,
    popupInfo: {
      id: 'popup-info',
      title: '',
      content: '',
      link: '',
      linktitle: '',
    },
  }),
  methods: {
    submit() {
      this.loading = true
      this.$http.post('/api/newsletters', { email: this.email }).then(
        () => {
          this.loading = false
          registrationHelpers.show(this, { title: '', text: 'Inscription réussie' })
        },
        err => {
          this.loading = false
          registrationHelpers.show(this, { title: 'Erreur', text: 'Vérifiez l\'adresse e-mail saisie et essayez à nouveau.' })
        },
      )
    },
  },
  components: {
    Simplert,
  },
}
</script>
